import 'whatwg-fetch';

let _config = null;

export default function getConfig() {
  if (_config) {
    return _config;
  }

  _config = fetch('config.json')
    .then(
      res => {
        if (res.ok) {
          return res.json();
        }
        return Promise.reject(new Error('Failed to load config!'));
      }
    )
    .then(
      config => {
        if (typeof config !== 'object' || typeof config.SERVLET_URL !== 'string') {
          return Promise.reject(new Error('Config was missing either API_URL or CLIENT_ID or both'));
        }

        return config;
      }
    );

  return _config;
}


// WEBPACK FOOTER //
// ./src/js/util/dao/helpers/getConfig.js